import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import HomeService from "../../../Services/HomeService";

export function WinnersFAQBlue() {
  const [open, setOpen] = useState(0);
  const [faqs, setFaqs] = useState([]);

  const fetchFaqs = async () => {
    try {
      const res = await HomeService?.getFaqs();
      if (res?.status) {
        setFaqs(res?.data || []);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const items = [
    {
      q: "How does Winners verify a property listing?",
      a: "Every listing passes through a 7-step verification — ownership trail, RERA, encumbrance, physical visit, pricing benchmark, builder reputation and legal clearance — before it goes live.",
    },
    {
      q: "Can I schedule a site visit through the platform?",
      a: "Yes. Pick any project, choose a time slot, and a dedicated relationship manager handles pickup, tour and follow-up.",
    },
    {
      q: "Are the ROI numbers shown realistic?",
      a: "We use a blend of micro-market data, builder history and resale trends from the last 36 months. We always show the methodology behind each number.",
    },
    {
      q: "What cities do you currently operate in?",
      a: "Twenty premium cities across NCR, UP and select metros — with active growth into tier-2 investment markets.",
    },
    {
      q: "Do you charge buyers a fee?",
      a: "No buyer fees. We're compensated by partner builders and project sponsors, with full disclosure on every listing.",
    },
  ];

  const displayItems = faqs.length > 0 ? faqs : items;

  return (
    <section className="ws-faq_blue">
      <div className="ws-faq-inner_blue">
        <div className="ws-faq-side_blue">
          <span className="ws-section-eyebrow_blue">FAQ</span>
          <h2 className="ws-section-heading_blue">
            Questions, answered with intent.
          </h2>
          <p>
            Everything you might want to know before exploring, visiting or
            investing in a Winners property. Can't find what you're looking for?
            Talk to us.
          </p>
          {/* <button>Contact our team</button> */}
          <button
            onClick={() => {
              window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
              });
            }}
          >
            Contact our team
          </button>
        </div>

        <div className="ws-faq-list_blue">
          {displayItems.map((it, i) => {
            const isOpen = open === i;
            const questionText = it.question || it.q;
            const answerText = it.answer || it.a;
            return (
              <div className="ws-faq-item_blue" key={i} data-open={isOpen}>
                <button
                  className="ws-faq-q_blue"
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  {questionText}
                  <span className="ws-faq-q-ic_blue">
                    <Plus size={14} />
                  </span>
                </button>
                {isOpen && <div className="ws-faq-a_blue">{answerText}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
